import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"phone, iphone, mobile"} maskId="square-filled-radius-0-stroke-1-IconPhone"><path fillRule="evenodd" clipRule="evenodd" d="M5 23V1H19V23H5ZM9 20V21H15V20H9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPhone;
